import { render, staticRenderFns } from "./FutureEvents.vue?vue&type=template&id=9011199c&scoped=true&"
import script from "./FutureEvents.vue?vue&type=script&lang=ts&"
export * from "./FutureEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9011199c",
  null
  
)

export default component.exports